import Layout from '@/layout'

// 结算管理路由
const settlementRoutes = {
  path: '/settlement',
  component: Layout,
  redirect: '/settlement/settlements-list',
  name: 'Settlement',
  meta: { title: '结算管理', icon: 'el-icon-trophy', requiresAuth: true },
  children: [
    {
      path: 'create-settlement',
      name: 'CreateSettlement',
      component: () => import('@/views/settlement/create-settlement.vue'),
      meta: { title: '结算发起', requiresAuth: true }
    },
    {
      path: 'settlements-list',
      name: 'SettlementsList',
      component: () => import('@/views/settlement/settlements-list.vue'),
      meta: { title: '结算列表', requiresAuth: true }
    },
    {
      path: 'settlement-detail/:id',
      name: 'SettlementDetail',
      component: () => import('@/views/settlement/settlement-detail.vue'),
      meta: { title: '结算单详情', requiresAuth: true },
      hidden: true
    },
    {
      path: 'attachments/:id',
      name: 'SettlementAttachments',
      component: () => import('@/views/settlement/settlement-attachments.vue'),
      meta: { title: '附件管理', requiresAuth: true },
      hidden: true
    },
    {
      path: 'forward-settlement/:id',
      name: 'ForwardSettlement',
      component: () => import('@/views/settlement/forward-settlement.vue'),
      meta: { title: '结算转发', requiresAuth: true },
      hidden: true
    },
    {
      path: 'invoice-management',
      name: 'InvoiceManagement',
      component: () => import('@/views/settlement/invoice-management.vue'),
      meta: { title: '开票管理', requiresAuth: true }
    },
    {
      path: 'payment-management',
      name: 'PaymentManagement',
      component: () => import('@/views/settlement/payment-management.vue'),
      meta: { title: '付款管理', requiresAuth: true }
    },
  ]
}

export default settlementRoutes 